import React from "react";
/************ Assets ************/
import Ms0365Icon from "assets/images/Auth/MicrosoftIcon.png";

export const Office365Login = () => {
  return (
    <button
      type="button"
      className="flex items-center justify-center flex-grow relative h-10 w-[86px] rounded-3xl border-2 border-textLink"
      aria-label="Microsoft 0365">
      <img src={Ms0365Icon} alt="" />
    </button>
  );
};
